enum TauxTVA {
  AUCUN = 0.0,
  SUPER_REDUIT = 2.1,
  REDUIT = 5.5,
  INTERMEDIAIRE = 10,
  NORMAL = 20,
}

export default TauxTVA
